import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import createComposeViewState from 'owa-calendar-compose-form-store/lib/utils/createComposeViewState';
import datapoints from 'owa-calendar-compose-form-store/lib/datapoints';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import initializeNewCalendarEventWithAttendees from 'owa-calendar-compose-form-store/lib/utils/initializeNewCalendarEventWithAttendee';
import isEntrySourceUndo from 'owa-calendar-compose-form-store/lib/utils/isEntrySourceUndo';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { dismissUndoNotification } from 'owa-calendar-actions';
import { FullComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import { initializeCompose } from 'owa-calendar-compose-form-actions';
import { internalShowFullCompose } from 'owa-calendar-compose-form-store/lib/actions/initActions/showFullCompose';
import { FullComposeFormViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

/**
 * Shows the full compose form by initializng the full compose form
 * @param {boolean} isCharmExplicitlySet If true, charm suggestions will not be provided until charm is unset.
 * @param {FullComposeEntrySourceType} entrySource
 * @param {boolean} createNewEvent If true we will reinitialize the compose store and create a new event based on system's defaults and current time.
 */
export default createLegacyActionWithDatapoint(
    'showFullComposeWithAttendee',
    datapoints.showFullComposeWithAttendee
)(async function showFullComposeWithAttendee(
    isCharmExplicitlySet: boolean,
    entrySource: FullComposeEntrySourceType,
    viewType: FullComposeFormViewType,
    requiredAttendees: AttendeeType[]
) {
    const isUndo = isEntrySourceUndo(entrySource);

    // If the form's entry source is undo, the notification is dismissed when the undo button is
    // selected. In all other cases, we dismiss the notification manually and reset the store.
    if (!isUndo) {
        dismissUndoNotification();
    }

    initializeCompose(initializeNewCalendarEventWithAttendees(requiredAttendees));

    const store = getComposeStore();
    const { event } = store;

    let viewState = createComposeViewState(
        event,
        isCharmExplicitlySet,
        viewType,
        false /* isAcceptPNT */,
        null /* extractionSourceId */
    );
    await internalShowFullCompose(viewState, entrySource);
});
